
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ConfirmationDialog, Dialog } from "../../Components/Dialog.js";
import { SubmitInput } from "../../Components/Input.js";
import { filter, map, tryHead, exists, toArray, empty, ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton } from "../../Components/Button.js";
import { Permissions_allowsInStorage, Permissions_allowsObject, Permission, Permissions_has } from "../../Shared/Roles.js";
import { usePermissions } from "../../UserPermissions.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { AssignQRCodeDialog } from "../Dialogs/QRCodeDialog.js";
import { TableControl$1, Table } from "../Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import Qr_Code from "../../../public/assets/icons/Qr_Code.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import Printer from "../../../public/assets/icons/Printer.svg";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { curry2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function AssignQrCodeByInputDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("");
    const setQrCodeInput = patternInput_1[1];
    const qrCodeInput = patternInput_1[0];
    const dependencies = [props.IsOpen];
    reactApi.useEffect(() => {
        setQrCodeInput("");
    }, dependencies);
    return createElement(Dialog, (Title = t("tool.assign_qr_code"), {
        Body: singleton(createElement(SubmitInput, {
            AutoFocus: true,
            ComponentState: "enabled",
            Label: t("general.qr_code"),
            OnChange: setQrCodeInput,
            OnSubmit: () => {
                props.OnSubmit(qrCodeInput);
            },
            TestId: "assign-qr-code-input",
            Value: qrCodeInput,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-assign-qr-code-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.save"),
            OnClick: () => {
                props.OnSubmit(qrCodeInput);
            },
            TestId: "save-assign-qr-code-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

function QrCodeTableBody(props) {
    const t = useTranslation()[0];
    const canOrderQrCodes = Permissions_has(usePermissions(), new Permission(104, []));
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedQrCodes = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsAssignQrCodeDialogOpen = patternInput_2[1];
    const isAssignQrCodeDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsAssignByInputQrCodeDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsDeleteQrCodeConfirmationDialogOpen = patternInput_4[1];
    const xs_1 = toList(delay(() => append(isAssignQrCodeDialogOpen ? singleton_1(createElement(AssignQRCodeDialog, {
        IsOpen: isAssignQrCodeDialogOpen,
        OnClose: () => {
            setIsAssignQrCodeDialogOpen(false);
        },
        OnQRCodeRead: props.OnAssignQrCode,
    })) : empty_1(), delay(() => append(singleton_1(createElement(AssignQrCodeByInputDialog, {
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsAssignByInputQrCodeDialogOpen(false);
        },
        OnSubmit: (qrCode) => {
            props.OnAssignQrCode(qrCode);
            setIsAssignByInputQrCodeDialogOpen(false);
        },
    })), delay(() => {
        let Title;
        return append(singleton_1(createElement(ConfirmationDialog, (Title = t("tool.dialog_delete_qr_code_confirmation_title"), {
            Description: t("tool.dialog_delete_qr_code_confirmation_description"),
            IsOpen: patternInput_4[0],
            OnClose: () => {
                setIsDeleteQrCodeConfirmationDialogOpen(false);
                setSelectedQrCodes(empty());
            },
            OnConfirm: () => {
                props.OnDeleteQrCodes(patternInput_1[0]);
                setIsDeleteQrCodeConfirmationDialogOpen(false);
                setSelectedQrCodes(empty());
            },
            Title: Title,
        }))), delay(() => {
            let TableRows, Options;
            return singleton_1(createElement(Table, (TableRows = toArray(props.QrCodes), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["qrCodeId", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: [new ColumnDefinition$1("qrCodeId", "", t("general.qr_code"), (Item) => (new CellContent(0, [Item])), "none", "text")],
                Controls: toList(delay(() => append(props.CanCreateQrCodes ? append(singleton_1(new TableControl$1(t("tool.assign_qr_code_by_scan"), Qr_Code(), (_arg_4) => {
                    setIsAssignQrCodeDialogOpen(true);
                }, false, false, "qr-code-table-scan-qrcode")), delay(() => singleton_1(new TableControl$1(t("tool.assign_qr_code_by_input"), Qr_Code(), (_arg_5) => {
                    setIsAssignByInputQrCodeDialogOpen(true);
                }, false, false, "qr-code-table-enter-qrcode")))) : empty_1(), delay(() => append(props.CanDeleteQrCodes ? singleton_1(new TableControl$1(t("tool.delete_qr_codes"), Recycle_Bin_1(), (codes) => {
                    setSelectedQrCodes(codes);
                    setIsDeleteQrCodeConfirmationDialogOpen(true);
                }, true, false, "qr-code-table-delete")) : empty_1(), delay(() => {
                    let matchValue, onPrintLabel;
                    return append((matchValue = props.OnPrintLabel, (matchValue == null) ? (empty_1()) : ((onPrintLabel = matchValue, singleton_1(new TableControl$1(t("labels.print.action_single"), Printer(), (_arg_6) => {
                        onPrintLabel();
                    }, false, false, "qr-code-table-print-label"))))), delay(() => (canOrderQrCodes ? singleton_1(new TableControl$1(t("general.order"), Qr_Code(), (_arg_7) => {
                        RouterModule_nav(ofArray(["shop"]), 1, 1);
                    }, false, false, "qr-code-table-order")) : empty_1())));
                })))))),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            }))));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function QrCodeTable(props) {
    const permissions = usePermissions();
    const allows = (permission) => Permissions_allowsObject(permissions, permission, props.UserData.UserId, props.Storage, undefined);
    return createElement(QrCodeTableBody, {
        CanCreateQrCodes: allows(new Permission(22, [])),
        CanDeleteQrCodes: allows(new Permission(23, [])),
        OnAssignQrCode: props.OnAssignQrCode,
        OnDeleteQrCodes: props.OnDeleteQrCodes,
        OnPrintLabel: unwrap(props.OnPrintLabel),
        QrCodes: props.QrCodes,
    });
}

export function StorageQrCodeTable(props) {
    const canUpdateStorage = Permissions_allowsInStorage(usePermissions(), new Permission(67, []), props.UserData.UserId, props.Storage.StorageId, props.Storage.AssignedUserIds);
    return createElement(QrCodeTableBody, {
        CanCreateQrCodes: canUpdateStorage,
        CanDeleteQrCodes: canUpdateStorage,
        OnAssignQrCode: props.OnAssignQrCode,
        OnDeleteQrCodes: props.OnDeleteQrCodes,
        QrCodes: props.QrCodes,
    });
}

export function ReceiverQrCodeTable(props) {
    const canManageQrCodes = Permissions_has(usePermissions(), new Permission(46, []));
    return createElement(QrCodeTableBody, {
        CanCreateQrCodes: canManageQrCodes,
        CanDeleteQrCodes: canManageQrCodes,
        OnAssignQrCode: props.OnAssignQrCode,
        OnDeleteQrCodes: props.OnDeleteQrCodes,
        QrCodes: props.QrCodes,
    });
}

export function QrCodeTableWithStorage(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const allowedIn = (permission, row) => Permissions_allowsInStorage(permissions, permission, props.UserData.UserId, unwrapStorageId(row.StorageId), row.AssignedUserIds);
    const canCreateQrCodes = exists(curry2(allowedIn)(new Permission(22, [])), props.Data);
    const canDeleteQrCodes = exists(curry2(allowedIn)(new Permission(23, [])), props.Data);
    const canOrderQrCodes = Permissions_has(permissions, new Permission(104, []));
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedQrCodes = patternInput_1[1];
    const selectedQrCodes = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsAssignQrCodeDialogOpen = patternInput_2[1];
    const isAssignQrCodeDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsAssignByInputQrCodeDialogOpen = patternInput_3[1];
    const isAssingByInputQrCodeDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setIsDeleteQrCodeConfirmationDialogOpen = patternInput_4[1];
    const isDeleteQrCodeConfirmationDialogOpen = patternInput_4[0];
    const xs_1 = toList(delay(() => {
        let matchValue, storageId;
        return append((matchValue = isAssignQrCodeDialogOpen, (matchValue == null) ? (empty_1()) : ((storageId = matchValue, singleton_1(createElement(AssignQRCodeDialog, {
            IsOpen: isAssignQrCodeDialogOpen != null,
            OnClose: () => {
                setIsAssignQrCodeDialogOpen(undefined);
            },
            OnQRCodeRead: (qrCodeId) => {
                props.OnAssignQrCode([qrCodeId, storageId]);
            },
        }))))), delay(() => {
            let matchValue_1, storageId_1;
            return append((matchValue_1 = isAssingByInputQrCodeDialogOpen, (matchValue_1 == null) ? (empty_1()) : ((storageId_1 = matchValue_1, singleton_1(createElement(AssignQrCodeByInputDialog, {
                IsOpen: isAssingByInputQrCodeDialogOpen != null,
                OnClose: () => {
                    setIsAssignByInputQrCodeDialogOpen(undefined);
                },
                OnSubmit: (qrCode) => {
                    props.OnAssignQrCode([qrCode, storageId_1]);
                    setIsAssignByInputQrCodeDialogOpen(undefined);
                },
            }))))), delay(() => {
                let qrCodeId_1, storageId_2, Title;
                return append((isDeleteQrCodeConfirmationDialogOpen == null) ? ((selectedQrCodes != null) ? (empty_1()) : (empty_1())) : ((selectedQrCodes == null) ? (empty_1()) : ((qrCodeId_1 = selectedQrCodes, (storageId_2 = isDeleteQrCodeConfirmationDialogOpen, singleton_1(createElement(ConfirmationDialog, (Title = t("tool.dialog_delete_qr_code_confirmation_title"), {
                    Description: t("tool.dialog_delete_qr_code_confirmation_description"),
                    IsOpen: isDeleteQrCodeConfirmationDialogOpen != null,
                    OnClose: () => {
                        setIsDeleteQrCodeConfirmationDialogOpen(undefined);
                        setSelectedQrCodes(undefined);
                    },
                    OnConfirm: () => {
                        props.OnDeleteQrCodes([qrCodeId_1, storageId_2]);
                        setIsDeleteQrCodeConfirmationDialogOpen(undefined);
                        setSelectedQrCodes(undefined);
                    },
                    Title: Title,
                }))))))), delay(() => {
                    let TableRows, Options;
                    return singleton_1(createElement(Table, (TableRows = toArray(props.Data), (Options = {
                        BorderStyle: "row",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["storageName", "asc"],
                        Fullscreen: false,
                        GlobalSearch: false,
                        RowSelection: "singleRow",
                        SaveTableConfiguration: false,
                    }, {
                        ColumnDefinitions: [new ColumnDefinition$1("storageName", "", t("general.storage"), (row_1) => (new CellContent(0, [row_1.StorageName])), "none", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (row_2) => (new CellContent(0, [row_2.StorageSpace])), "none", "text"), new ColumnDefinition$1("storageLocation", "", t("general.location"), (row_3) => (new CellContent(0, [row_3.Location])), "none", "text"), new ColumnDefinition$1("qrCodeId", "", t("general.qr_code"), (row_4) => (new CellContent(0, [row_4.QrCode])), "none", "text")],
                        Controls: toList(delay(() => append(canCreateQrCodes ? append(singleton_1(new TableControl$1(t("tool.assign_qr_code_by_scan"), Qr_Code(), (row_5) => {
                            const matchValue_3 = tryHead(row_5);
                            let matchResult, row_7;
                            if (matchValue_3 != null) {
                                if (allowedIn(new Permission(22, []), matchValue_3)) {
                                    matchResult = 0;
                                    row_7 = matchValue_3;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    setIsAssignQrCodeDialogOpen(row_7.StorageId);
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        }, true, false, "qr-code-table-assign-qr-code")), delay(() => singleton_1(new TableControl$1(t("tool.assign_qr_code_by_input"), Qr_Code(), (row_8) => {
                            const matchValue_4 = tryHead(row_8);
                            let matchResult_1, row_10;
                            if (matchValue_4 != null) {
                                if (allowedIn(new Permission(22, []), matchValue_4)) {
                                    matchResult_1 = 0;
                                    row_10 = matchValue_4;
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                            switch (matchResult_1) {
                                case 0: {
                                    setIsAssignByInputQrCodeDialogOpen(row_10.StorageId);
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        }, true, false, "qr-code-table-enter-qrcode")))) : empty_1(), delay(() => append(canDeleteQrCodes ? singleton_1(new TableControl$1(t("tool.delete_qr_codes"), Recycle_Bin_1(), (row_11) => {
                            const matchValue_5 = tryHead(row_11);
                            let matchResult_2, row_13;
                            if (matchValue_5 != null) {
                                if (allowedIn(new Permission(23, []), matchValue_5)) {
                                    matchResult_2 = 0;
                                    row_13 = matchValue_5;
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                            switch (matchResult_2) {
                                case 0: {
                                    setSelectedQrCodes(row_13.QrCode);
                                    setIsDeleteQrCodeConfirmationDialogOpen(row_13.StorageId);
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        }, true, false, "qr-code-table-delete")) : empty_1(), delay(() => {
                            let matchValue_6, onPrintLabel;
                            return append((matchValue_6 = props.OnPrintLabel, (matchValue_6 == null) ? (empty_1()) : ((onPrintLabel = matchValue_6, singleton_1(new TableControl$1(t("labels.print.action_single"), Printer(), (_arg_4) => {
                                onPrintLabel();
                            }, false, false, "qr-code-table-print-label"))))), delay(() => (canOrderQrCodes ? singleton_1(new TableControl$1(t("general.order"), Qr_Code(), (_arg_5) => {
                                RouterModule_nav(ofArray(["shop"]), 1, 1);
                            }, false, false, "qr-code-table-order")) : empty_1())));
                        })))))),
                        Options: Options,
                        TableKey: "not-defined-table",
                        TableRows: TableRows,
                    }))));
                }));
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function AssetIdentifierTable(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const allows = (permission) => Permissions_allowsObject(permissions, permission, props.UserData.UserId, props.Storage, undefined);
    const canCreateQrCodes = allows(new Permission(22, []));
    const canDeleteQrCodes = allows(new Permission(23, []));
    const canOrderQrCodes = Permissions_has(permissions, new Permission(104, []));
    const patternInput_1 = reactApi.useState(empty());
    const setSelectedAssetIdentifiers = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsAssignQrCodeDialogOpen = patternInput_2[1];
    const isAssignQrCodeDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsAssignByInputQrCodeDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsDeleteQrCodeConfirmationDialogOpen = patternInput_4[1];
    const xs_1 = toList(delay(() => append(isAssignQrCodeDialogOpen ? singleton_1(createElement(AssignQRCodeDialog, {
        IsOpen: isAssignQrCodeDialogOpen,
        OnClose: () => {
            setIsAssignQrCodeDialogOpen(false);
        },
        OnQRCodeRead: props.OnAssignQrCode,
    })) : empty_1(), delay(() => append(singleton_1(createElement(AssignQrCodeByInputDialog, {
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsAssignByInputQrCodeDialogOpen(false);
        },
        OnSubmit: (qrCode) => {
            props.OnAssignQrCode(qrCode);
            setIsAssignByInputQrCodeDialogOpen(false);
        },
    })), delay(() => {
        let Title;
        return append(singleton_1(createElement(ConfirmationDialog, (Title = t("tool.dialog_delete_qr_code_confirmation_title"), {
            Description: t("tool.dialog_delete_qr_code_confirmation_description"),
            IsOpen: patternInput_4[0],
            OnClose: () => {
                setIsDeleteQrCodeConfirmationDialogOpen(false);
                setSelectedAssetIdentifiers(empty());
            },
            OnConfirm: () => {
                props.OnDeleteQrCodes(map((_arg_3) => _arg_3.Value, filter((assetIdentifier) => (assetIdentifier.Kind === "qrCode"), patternInput_1[0])));
                setIsDeleteQrCodeConfirmationDialogOpen(false);
                setSelectedAssetIdentifiers(empty());
            },
            Title: Title,
        }))), delay(() => {
            let TableRows, Options;
            return singleton_1(createElement(Table, (TableRows = toArray(props.AssetIdentifiers), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["value", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: [new ColumnDefinition$1("value", "", t("general.code"), (row) => (new CellContent(0, [row.Value])), "none", "text"), new ColumnDefinition$1("kind", "", t("general.kind"), (row_1) => {
                    let matchValue;
                    return new CellContent(0, [(matchValue = row_1.Kind, (matchValue === "qrCode") ? t("general.qr_code") : ((matchValue === "tracker") ? t("general.tracker") : t("general.nfc_tag")))]);
                }, "none", "text")],
                Controls: toList(delay(() => append(canCreateQrCodes ? append(singleton_1(new TableControl$1(t("tool.assign_qr_code_by_scan"), Qr_Code(), (_arg_5) => {
                    setIsAssignQrCodeDialogOpen(true);
                }, false, false, "qr-code-table-scan-qrcode")), delay(() => singleton_1(new TableControl$1(t("tool.assign_qr_code_by_input"), Qr_Code(), (_arg_6) => {
                    setIsAssignByInputQrCodeDialogOpen(true);
                }, false, false, "qr-code-table-enter-qrcode")))) : empty_1(), delay(() => append(canDeleteQrCodes ? singleton_1(new TableControl$1(t("tool.delete_qr_codes"), Recycle_Bin_1(), (assetIdentifiers) => {
                    setSelectedAssetIdentifiers(assetIdentifiers);
                    setIsDeleteQrCodeConfirmationDialogOpen(true);
                }, true, false, "qr-code-table-delete")) : empty_1(), delay(() => {
                    let matchValue_1, onPrintLabel;
                    return append((matchValue_1 = props.OnPrintLabel, (matchValue_1 == null) ? (empty_1()) : ((onPrintLabel = matchValue_1, singleton_1(new TableControl$1(t("labels.print.action_single"), Printer(), (_arg_7) => {
                        onPrintLabel();
                    }, false, false, "qr-code-table-print-label"))))), delay(() => (canOrderQrCodes ? singleton_1(new TableControl$1(t("general.order"), Qr_Code(), (_arg_8) => {
                        RouterModule_nav(ofArray(["shop"]), 1, 1);
                    }, false, false, "qr-code-table-order")) : empty_1())));
                })))))),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            }))));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

